export default "__VITE_ASSET__fb3381ef__"